import { dispatcher } from 'dispatcher';
import { useEffect } from 'react';

export const useCMSIntegration = ({ page, fetchPageInfo }) => {
    useEffect(() => {
        if (!page) {
            return;
        }

        // Re-fetch page info by CMS when needed.
        const reFetchPageInfo = () => fetchPageInfo(Date.now());

        dispatcher.listen('page-in-popup:update:request', reFetchPageInfo);

        return () => {
            dispatcher.removeListener('page-in-popup:update:request', reFetchPageInfo);
        };
    });
};
